export default {
  'play-session.workspace': async () => {
    const module = await import('./play-session-workspace-component.js');
    return module.PlaySessionWorkspaceComponent;
  },
};
